import React from "react";
import Grid from "../Grid";
import Card from "../Card";
import { LoaderCircle } from "lucide-react";
import Spacing from "../Spacing";
import { exchangeDate, numberWithCommas } from "../../helpers";

export default function BillingOverViewSection({ billingOverviewDataCounts, billingOverviewLoader }) {

  return (
    <Grid variant="docpro_grid_gap_10 docpro_grid_col_4">
      <span className="docpro_card_1_link">
        <Card variant="docpro_card_md docpro_card_1">
          <h3 className="docpro_fs_14 docpro_mb_0 docpro_ternary_color">
            Latest billing date
          </h3>
          <Spacing lg="4" sm="4" />
          <div>
            {!billingOverviewLoader ?
              <p className="docpro_fw_500 docpro_fs_24 docpro_primary_color docpro_mb_0">
                {billingOverviewDataCounts?.latest_due_date !== null ? exchangeDate(billingOverviewDataCounts?.latest_due_date) : "-"}
              </p>
            :
              <div className="flex items-center loading" style={{ width: '100%', height: '100%', justifyContent: 'center', background: 'var(--white)', borderRadius: '12px' }}>
                <span className="docpro_loading" style={{ position: 'inherit' }}>
                  <LoaderCircle width={36} height={36} />
                </span>
              </div>
            }
          </div>
        </Card>
      </span>
      <span className="docpro_card_1_link">
        <Card variant="docpro_card_md docpro_card_1">
          <h3 className="docpro_fs_14 docpro_mb_0 docpro_ternary_color">
            Coding done
          </h3>
          <Spacing lg="4" sm="4" />
          <div>
            {!billingOverviewLoader ?
              <p className="docpro_fw_500 docpro_fs_24 docpro_primary_color docpro_mb_0">
                {numberWithCommas(billingOverviewDataCounts?.total_coding_done_count || 0)}
              </p>
            :
              <div className="flex items-center loading" style={{ width: '100%', height: '100%', justifyContent: 'center', background: 'var(--white)', borderRadius: '12px' }}>
                <span className="docpro_loading" style={{ position: 'inherit' }}>
                  <LoaderCircle width={36} height={36} />
                </span>
              </div>
            }
          </div>
        </Card>
      </span>
      <span className="docpro_card_1_link">
        <Card variant="docpro_card_md docpro_card_1">
          <h3 className="docpro_fs_14 docpro_mb_0 docpro_ternary_color">
            Charting done
          </h3>
          <Spacing lg="4" sm="4" />
          <div>
            {!billingOverviewLoader ?
              <p className="docpro_fw_500 docpro_fs_24 docpro_primary_color docpro_mb_0">
                {numberWithCommas(billingOverviewDataCounts?.total_charting_done_count || 0)}
              </p>
            :
              <div className="flex items-center loading" style={{ width: '100%', height: '100%', justifyContent: 'center', background: 'var(--white)', borderRadius: '12px' }}>
                <span className="docpro_loading" style={{ position: 'inherit' }}>
                  <LoaderCircle width={36} height={36} />
                </span>
              </div>
            }
          </div>
        </Card>
      </span>
      <span className="docpro_card_1_link">
        <Card variant="docpro_card_md docpro_card_1">
          <h3 className="docpro_fs_14 docpro_mb_0 docpro_ternary_color justify-between">
            Invoice total
            {/* <div className="docpro_mb_0 pointer docpro_icon_btn overview" style={{ width: 'auto', height: 'auto' }}>
              <span className="docpro_accent_color">See Cost Breakdown</span>
              <div className="docpro_tip">
                <span>. . . . . . . . . . . . . . .</span>
              </div>
            </div> */}
          </h3>
          <Spacing lg="4" sm="4" />
          <div>
            {!billingOverviewLoader ?
              <p className="docpro_fw_500 docpro_fs_24 docpro_primary_color docpro_mb_0">
                {`$${numberWithCommas(
                  billingOverviewDataCounts?.total_due_count
                    ? billingOverviewDataCounts?.total_due_count.toFixed(2)
                    : 0.00
                  )}`
                }
              </p>
            :
              <div className="flex items-center loading" style={{ width: '100%', height: '100%', justifyContent: 'center', background: 'var(--white)', borderRadius: '12px' }}>
                <span className="docpro_loading" style={{ position: 'inherit' }}>
                  <LoaderCircle width={36} height={36} />
                </span>
              </div>
            }
          </div>
        </Card>
      </span>
    </Grid>
  );
}
